export const DndItemTypes = {
  ACTION: 'action',
  STEP: 'step',
  VIALBUTTON: 'vialButton'
}
